module.exports = __webpack_public_path__ + "img/category-favorite-hover.ab55db1b.png";